import React, { useEffect } from 'react';
import { SubmitHandler, useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import ActionButton from '../atoms/ActionButton';
import DatePicker from '../atoms/DatePicker';
import BackButton from '../atoms/BackButton';
import { useNavigate } from 'react-router-dom';

const formSchema = z.object({
  message: z
    .string()
    .min(1, 'メッセージを入力してください')
    .max(140, '140文字以内で入力してください'),
});

export type FormData = z.infer<typeof formSchema>;

interface MessageFormProps {
  defaultValues?: FormData;
  onSubmit?: SubmitHandler<FormData>;
}

const MessageForm: React.FC<MessageFormProps> = ({
  defaultValues,
  onSubmit = () => {},
}) => {
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    control,
    reset,
    formState: { errors },
  } = useForm<FormData>({
    resolver: zodResolver(formSchema),
    defaultValues,
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (defaultValues) {
      reset(defaultValues);
    }
  }, [defaultValues, reset]);

  return (
    <div className='p-form-box -ai'>
      <form onSubmit={handleSubmit(onSubmit)} className='p-form -ai'>
        <dl className='p-form__item'>
          <dt>
            <label htmlFor='message' className='p-form__label'>
              メッセージ
            </label>
          </dt>
          <dd>
            <textarea
              className='p-form__textarea'
              placeholder='140文字以内'
              {...register('message')}
            />
            {errors.message && (
              <p className='c-txt-error'>{errors.message.message}</p>
            )}
            <div style={{ textAlign: 'right', marginTop: '8px' }}>
              {watch('message')?.length || 0}/140文字
            </div>
          </dd>
        </dl>

        <div className='u-mt50 c-btn-rows'>
          <BackButton size='small' onClick={() => navigate('/question')}>
            戻る
          </BackButton>
          <ActionButton size='small' type='submit'>
            次へ
          </ActionButton>
        </div>
      </form>
    </div>
  );
};

export default MessageForm;
